<template>
    <div class="search-box">
        <div class="search-title" v-if="title">{{title}}</div>
        <div class="search-body">
            <div class="search-card-title" v-if="searchTitle">{{searchTitle}}</div>
            <slot></slot>
        </div>
    </div>    
</template>
<script>
export default {
    name:'SearchBox',
    props:{
        title:{
            type:String,
            default:''
        },
        searchTitle:{
            type:String,
            default:''
        }
    },
    data(){
        return {
            title2:String
        }
    }
}
</script>

<style scoped lang="less">
.search-box{ 
    width:100%;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);

    .search-title{ 
        width:100%; 
        height: 48px; 
        border-bottom:1px solid rgba(227,232,238,1); 
        line-height: 48px; 
        font-size:14px; 
        font-weight:bold; 
        color:rgba(70,76,91,1);  
        padding-left: 24px; 
    }

    .search-body{ 
        padding: 24px; 
        padding-bottom: 16px;

        .search-card-title{
            margin-top: -6px;
            margin-bottom: 8px;
            font-size: 14px;
            font-weight: bold;
            color: #464C5B;
        }
    }
}
</style>